export default "__VITE_ASSET__B3NxhD_C__"